exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inputW_33a48e2{width:250px!important}.tip_479f48a{background-color:#fffbe6;height:102px;padding:16px 24px 16px 62px;box-sizing:border-box;border:1px solid;border-color:#ffe58f}.tip_479f48a>p{line-height:26px;font-size:14px}.label_27d1735{color:#1890ff;cursor:pointer}.wrapper_66f30f9{text-align:center}", ""]);

// exports
exports.locals = {
	"inputW": "inputW_33a48e2",
	"tip": "tip_479f48a",
	"label": "label_27d1735",
	"wrapper": "wrapper_66f30f9"
};